'use strict'

export let norwegian_endStage={
  status: {
    green: "Etappen er gjennomført innenfor toleransegrensene",
    yellow: "Saker eller risiko har oppstått. Hvis det ikke blir håndtert vil prosjektets prognose ende opp med å overskride toleransegrensene",
    red: "Etappen har overskredet toleransegrensene. En unntaksplan for prosjektet er muligens nødvendig."
  }
}



// WEBPACK FOOTER //
// ./views/components/labels/norwegian_endStage.js